// extracted by mini-css-extract-plugin
export const websites = "Websites-module--websites--2uAd1";
export const header = "Websites-module--header--nb1Ru";
export const designed = "Websites-module--designed--uB4-L";
export const websites_img = "Websites-module--websites_img--2ZvQy";
export const websites_feature = "Websites-module--websites_feature--2Raoj";
export const bouncy = "Websites-module--bouncy--bTtaH";
export const pop = "Websites-module--pop--JOqS3";